<trap-focus [enableFocusTrap]="true" [enableArrowKeys]="true">
  <app-modal [modalId]="modalId" class="bid_modal" *transloco="let convert;">
    @if (withdrawState === 'withDrawModalOpened') {
      <section role="alert">
        <header class="modal__header">
          <h1
            class="modal__title"
            id="auto-bid-withdraw-modal-title"
            aria-labelledby="auto-bid-withdraw-modal-title-inner"
            tabindex="-1"
            >
            <span class="visually-hidden" id="auto-bid-withdraw-modal-title-inner">{{ convert('vehicles.autoBidWithdrawModal.withdrawAutobid') }}</span>
            <span aria-hidden="true">{{ convert('vehicles.autoBidWithdrawModal.withdrawAutobid') }}</span>
          </h1>
        </header>
      </section>
      <div class="modal__content">
        <div class="modal__body">
          <span class="visually-hidden" id="auto-bid-withdraw-modal-body-text" [innerHTML]="convert('vehicles.autoBidWithdrawModal.contentWithdrawAutobid',{bidAmount:getAutoBidAmount,auctionTime:localizeDateAndTime(item.auctionStartTime) ,itemVin:item.vin})">
          </span>
          <p aria-hidden="true" aria-labelledby="auto-bid-withdraw-modal-body-text" [innerHTML]="convert('vehicles.autoBidWithdrawModal.contentWithdrawAutobid',{bidAmount:bidItemAmount ,auctionTime:localizeDateAndTime(item.auctionStartTime) ,itemVin:item.vin})">
          </p>
          <p>
            {{ convert('vehicles.autoBidWithdrawModal.agreement') }}
          </p>
          @if (errorMessage) {
            <p class="text-danger fw-bold" #error aria-live="polite">{{ errorMessage }}</p>
          }
        </div>
        <div class="d-flex flex-column flex-lg-row lg-justify-content-start modal_actions" tabindex="0">
          <button
            id="bm_bid_button"
            class="btn btn-primary stockwave-bid-button"
            type="submit"
            (click)="confirm()"
            data-track-elem="button"
            data-track-name="Confirm"
            >
            {{ convert('common.btnConfirm') }}
          </button>
          <button
            id="bm_cancel_button"
            class="ms-lg-2 mt-3 mt-lg-0 btn btn-link"
            type="button"
            (click)="close()"
            data-track-elem="button"
            data-track-name="Cancel"
            data-track-trigger="close"
            >
            <span>{{ convert('common.btnCancel') }}</span>
          </button>
        </div>
      </div>
      <div class="modal-close-container">
        <button
          id="bm_close_x_button"
          class="modal__close btn-link"
          [attr.aria-label]="convert('common.modalClose')"
          (click)="close()"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    }
    @if (withdrawState === 'withdrawing') {
      <app-action-submitting actionText="{{ convert('vehicles.autoBidWithdrawModal.actionText') }}"></app-action-submitting>
    }
    @if (withdrawState === 'withdrawComplete') {
      <app-action-submitted
        (close)="close()"
        actionText=" {{ convert('vehicles.autoBidWithdrawModal.actionAutobid') }}"
        [tenantName]="tenantName"
      ></app-action-submitted>
    }
  </app-modal>
</trap-focus>
